import { defineComponent as _defineComponent } from 'vue'
import { IconItem } from "@/interface/image";
import { getImages } from "@/store/store-image";
import { computed } from "vue";
import MapImage from "@components/MapImage.vue";
import { inputText } from "@/components/input";

export default /*#__PURE__*/_defineComponent({
  __name: 'input-image',
  props: {
  value: {
    required: true
  },
  mapId: {
    type: String,
    required: true
  }
},
  emits: ["input", "change"],
  setup(__props, { emit }) {

const props = __props



const form = computed({
  get() {
    return props.value;
  },
  set(value) {
    if (!value) {
      value = undefined;
    }
    emit("input", value);
    emit("change", value);
  }
});
const images_convert = computed(() => getImages(props.mapId));
function onToggleImage(image: IconItem) {
  if (form.value == image.id) {
    form.value = undefined;
  } else {
    form.value = image.id;
  }
}

return { __sfc: true,props, emit, form, images_convert, onToggleImage, MapImage, inputText }
}

})